import * as React from "react";
import './footer.css'
const Footer: React.FC = () => {
  return (
    <div id="footer-items" style={{ width: "980px", marginTop: "50px", textAlign: "center" }}>
      <ul id="nav-footer">
        <li>
          <a
            href="http://www.clearstream.com/ci/dispatch/en/kir/ci_nav/home?displayText=footerDB"
            target="_blank"
            rel="noreferrer"
          >
            @ Clearstream
          </a>
        </li>
        <li>
          <a
            href="http://www.clearstream.com/ci/dispatch/en/kir/ci_nav/home?displayText=footerIMP"
            target="_blank"
            rel="noreferrer"
          >
            Imprint
          </a>
        </li>
        <li>
          <a
            href="http://www.clearstream.com/ci/dispatch/en/kir/ci_nav/home?displayText=footerDisclaimer"
            target="_blank"
            rel="noreferrer"
          >
            Disclaimer
          </a>
        </li>
        <li>
          <a
            href="http://www.clearstream.com/ci/dispatch/en/kir/ci_nav/home?displayText=footerPrivacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="http://www.clearstream.com/ci/dispatch/en/kir/ci_nav/home?displayText=footerTrademarks"
            target="_blank"
            rel="noreferrer"
          >
            Trademarks
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Footer;

